var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_2369_18815)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2369_18815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 11.6654C22.6673 12.954 19.6827 13.9987 16.0007 13.9987C12.3187 13.9987 9.33398 12.954 9.33398 11.6654C9.33398 10.3767 12.3187 9.33203 16.0007 9.33203C19.6827 9.33203 22.6673 10.3767 22.6673 11.6654Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 15.6641C22.6673 16.9527 19.6827 17.9974 16.0007 17.9974C12.3187 17.9974 9.33398 16.9527 9.33398 15.6641",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 11.6641V19.9974C22.6673 21.2861 19.6827 22.3307 16.0007 22.3307C12.3187 22.3307 9.33398 21.2861 9.33398 19.9974V11.6641",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2369_18815",
    x1: 32,
    y1: 32,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#277AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C6F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2369_18815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLast);
export default __webpack_public_path__ + "static/media/data-last.6b6f4bc1141ba49466953752b7942945.svg";
export { ForwardRef as ReactComponent };